module.exports = __webpack_public_path__ + "static/img/logo.2cdae8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 396
// module chunks = 63